import { render, staticRenderFns } from "./TixTabs.vue?vue&type=template&id=7b80a5b4&"
import script from "./TixTabs.vue?vue&type=script&lang=ts&"
export * from "./TixTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports